var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceMobileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DeviceMobileCamera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 2.5H13C12.0054 2.5 11.0516 2.89509 10.3483 3.59835C9.64509 4.30161 9.25 5.25544 9.25 6.25V33.75C9.25 34.7446 9.64509 35.6984 10.3483 36.4016C11.0516 37.1049 12.0054 37.5 13 37.5H28C28.9946 37.5 29.9484 37.1049 30.6517 36.4016C31.3549 35.6984 31.75 34.7446 31.75 33.75V6.25C31.75 5.25544 31.3549 4.30161 30.6517 3.59835C29.9484 2.89509 28.9946 2.5 28 2.5ZM29.25 33.75C29.25 34.0815 29.1183 34.3995 28.8839 34.6339C28.6495 34.8683 28.3315 35 28 35H13C12.6685 35 12.3505 34.8683 12.1161 34.6339C11.8817 34.3995 11.75 34.0815 11.75 33.75V6.25C11.75 5.91848 11.8817 5.60054 12.1161 5.36612C12.3505 5.1317 12.6685 5 13 5H28C28.3315 5 28.6495 5.1317 28.8839 5.36612C29.1183 5.60054 29.25 5.91848 29.25 6.25V33.75ZM22.375 9.375C22.375 9.74584 22.265 10.1084 22.059 10.4167C21.853 10.725 21.5601 10.9654 21.2175 11.1073C20.8749 11.2492 20.4979 11.2863 20.1342 11.214C19.7705 11.1416 19.4364 10.963 19.1742 10.7008C18.912 10.4386 18.7334 10.1045 18.661 9.74079C18.5887 9.37708 18.6258 9.00008 18.7677 8.65747C18.9096 8.31486 19.15 8.02202 19.4583 7.81599C19.7666 7.60997 20.1292 7.5 20.5 7.5C20.9973 7.5 21.4742 7.69754 21.8258 8.04917C22.1775 8.40081 22.375 8.87772 22.375 9.375Z",
    fill: "#FF7A2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMobileCamera);
export default __webpack_public_path__ + "static/media/DeviceMobileCamera.8baf0c9a2dd73ea801a5390de9a07160.svg";
export { ForwardRef as ReactComponent };